<template>
  <div>

    <memlist-card>
      
      <m-row>
        <m-col lg="12" class="d-flex justify-end">
          <memlist-icon-button
            icon="menu-icon flaticon2-plus"
            :text="$t('TAB.SETTINGS_DNS.NEW_ADDRESS')"
            variant="primary"
            @click="new_email_clicked"
          />
        </m-col>
      </m-row>


      <memlist-modal ref="new-address-modal" title="Ny adress" >
        <memlist-text-input
          id="email-field"
          v-model="new_email"
          title="Epostadress"
          layout="vertical"
        />
        <m-row class="mt-4">
          <m-col lg="12">
            <memlist-button variant="secondary" @click="$refs['new-address-modal'].hide()">{{$t('COMMON.CANCEL')}}</memlist-button>
            <memlist-button variant="primary" @click="save_email_clicked">{{$t('COMMON.SAVE')}}</memlist-button>
          </m-col>
        </m-row>

      </memlist-modal>

      <memlist-static-table
        class="mt-4"
        id="email-table"
        :fields="headers"
        :items="items">

        <template #cell(actions)="data">
          <div class='d-flex justify-content-end'>
            <memlist-table-button
              @click="delete_email_clicked(data.item)"
              svg="/assets/svg/trash2.svg"
              :tooltip="$t('COMMON.DELETE')"
            />
          </div>
        </template>

      </memlist-static-table>

    </memlist-card>

  </div>
</template>

<script>
import axios from 'axios';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { mapGetters } from 'vuex';

export default {

  name: 'EmailsTab',
  mixins: [ toasts ],

  components: {

  },

  computed: {
    ...mapGetters(['currentCompanyId']),
  },

  watch: {
  },

  methods: {

    new_email_clicked() {
      this.$refs['new-address-modal'].show();
    },

    save_email_clicked() {
      this.$refs['new-address-modal'].show();
      axios
        .post(`/email/valid`, {email: this.new_email})
        .then(res => {
          if (res.status === 201) {
            this.items.push(res.data);
            this.toastr('success', this.$t('COMMON.OK'), this.$t('TAB.SETTINGS_DNS.ADDED'));
          }
          else {
            this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.SETTINGS_DNS.UNABLE_ADD'));
          }
        })
        .catch(err => {
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.SETTINGS_DNS.UNABLE_ADD'));
        });
    },

    delete_email_clicked(email) {
      axios
        .delete(`/email/valid/${email.id}`)
        .then(res => {
          if (res.status === 204) {
            this.items = this.items.filter(item => item.id !== email.id);
            if (this.template && this.template.id === template.id) { this.template = null; }
            this.toastr('success', this.$t('COMMON.OK'), this.$t('TAB.SETTINGS_DNS.DELETED'));
          } else {
            this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.SETTINGS_DNS.UNABLE_DELETE'));
          }
        }).catch(err => {
          console.log(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.SETTINGS_DNS.UNABLE_DELETE'));
        });
    },

    load_emails() {
      this.items = [];
      const loader = this.$loading.show();
      axios
        .get(`/email/valid`)
        .then(res => {
          if (res.status === 200) {
            this.items = res.data;
          }
          else {
            this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.SETTINGS_DNS.UNABLE_LIST'));
          }
          loader && loader.hide();
        })
        .catch(err => {
          console.error(err);
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TAB.SETTINGS_DNS.UNABLE_LIST'));
          loader && loader.hide();
        });

    },
  },

  mounted() {
    this.load_emails();
  },

  data() {
    return {
      new_email: '',
      items: [],
      headers: [
        {
          key: 'email',
          show: true,
          sortable: true,
          label: 'E-mail',
          thClass: 'td-overflow',
          tdClass: 'td-overflow'
        },
        {
          key: 'is_postmark_valid',
          show: true,
          sortable: true,
          label: 'Postmark',
          thClass: 'td-short3',
          tdClass: 'td-short3',
          formatter: (_, __, item) => {
            return item.is_postmark_valid ? this.$t('COMMON.YES') : this.$t('COMMON.NO')
          },
        },
        {
          key: 'actions',
          show: true,
          sortable: false,
          label: this.$t('COMMON.ACTIONS'),
          thClass: 'td-short3',
          tdClass: 'td-short3',
        }
      ]
    };
  }
};

</script>
